module.exports = __webpack_public_path__ + "static/media/Graphic19.e1b4654b.png";